<template>
  <div
    class="teammate-fill-strip"
    :class="`teammate-fill-strip--${fill.status}`"
    v-if="fill"
  >
    <div class="teammate-fill-strip__icon">
      <font-awesome-icon
        :icon="['fas', 'spinner']"
        spin
        v-if="fill.status === 'pending'"
      />
      <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" v-else />
    </div>

    <div class="teammate-fill-strip__body">
      <template v-if="fill.status === 'pending'">
        GNey is reading the form…
      </template>

      <template v-else-if="fill.status === 'done'">
        GNey filled {{ fill.filled.length }}
        {{ fill.filled.length === 1 ? "field" : "fields" }}
        <span
          class="teammate-fill-strip__chip"
          v-for="name in filledDisplayNames"
          :key="name"
        >{{ name }}</span>
      </template>

      <template v-else>
        {{ fill.message || "GNey could not fill the form this time." }}
      </template>
    </div>

    <div class="teammate-fill-strip__actions" v-if="fill.status !== 'pending'">
      <fts-btn
        sm
        outline
        text-transform-init
        @click="undo"
        v-if="fill.status === 'done'"
      >
        Undo
      </fts-btn>
      <fts-btn text icon sm @click="dismiss">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </div>
  </div>
</template>

<script>
/* §4.3.1 live-form GNey fill status strip. The single narrative surface for a fill run:
   pending -> "reading", done -> count + field chips + atomic Undo, error -> one quiet line.
   Never a modal, never blocks the form — its failure mode is "the form is just a form". */
import commons from "../commons/commons";
import FTSBtn from "./FTSBtn";

export default {
  components: {
    "fts-btn": FTSBtn,
  },
  computed: {
    fill() {
      return this.$store.state.teammateFill;
    },
    /* filled keys are data keys — show the designer's display names on the chips */
    filledDisplayNames() {
      if (!this.fill || !Array.isArray(this.fill.filled)) return [];
      const elements = commons.getAllElements(null, this.$store.state.form) || [];
      return this.fill.filled.map((key) => {
        const element = elements.find(
          (x) => x && (x.fieldName === key || x.displayName === key)
        );
        return (element && element.displayName) || key;
      });
    },
  },
  methods: {
    undo() {
      this.$store.dispatch("teammateFillUndo");
    },
    dismiss() {
      this.$store.dispatch("teammateFillDismiss");
    },
  },
};
</script>

<style lang="scss" scoped>
.teammate-fill-strip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
  padding: 0.375rem 0.625rem;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  background-color: rgba(var(--fts-primary-rgb), 0.07);
  color: var(--fts-text);

  &.teammate-fill-strip--error {
    background-color: rgba(var(--fts-text-rgb, 0, 0, 0), 0.05);
    opacity: 0.85;
  }

  .teammate-fill-strip__icon {
    color: var(--fts-primary);
    flex-shrink: 0;
  }

  .teammate-fill-strip__body {
    flex: 1;
    min-width: 0;
  }

  .teammate-fill-strip__chip {
    display: inline-block;
    margin: 0.125rem 0 0.125rem 0.25rem;
    padding: 0 0.375rem;
    border-radius: 0.75rem;
    background-color: rgba(var(--fts-primary-rgb), 0.12);
    font-size: 0.75rem;
  }

  .teammate-fill-strip__actions {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
  }
}
</style>
